export default __webpack_public_path__ + "static/care-month-f3f6a67cc0dda84e59030a8f4f6c5366.webp";